<template>
    <!-- ongoing white label -->
    <div v-if="co_ongoing_b && p_whiteLabel_c.wl_logoUrl_s"
        class="lc_splashContainer TQ_height_100vh TQ_animation_fadeOut_3500ms"
        :style="{zIndex: gv_zIndex.app_splashScreen, background: p_whiteLabel_c.wl_backgroundColor_s}">

        <div class="TQ_centerAbsolute">
            <img :src="p_whiteLabel_c.wl_logoUrl_s" class="lc_logo TQ_maxWidth_200px TQ_width_100p"/>
            <div class="lc_url TQ_textColor_white TQ_center" :style="{color: p_whiteLabel_c.wl_color_s}">
                {{ p_whiteLabel_c.wl_title_s }}
            </div>
        </div>
    </div>

    <!-- tq spalsh screen -->
    <div v-else-if="!co_playerEntryTicket_b && co_showSplashScreen_b" 
        class="lc_splashContainer TQ_height_100vh TQ_animation_fadeOut_3500ms TQ_bg_purple"
         :style="{'zIndex': gv_zIndex.app_splashScreen}">

        <div class="TQ_centerAbsolute">
            <full-logo class="lc_logo  TQ_maxWidth_200px TQ_width_100p"/>
            <div class="lc_url TQ_animation_show_700ms_w1500ms TQ_textColor_white TQ_center ">
                TravelQuest
            </div>
        </div>
    </div>
</template>

<script>
    import FullLogo from "../../components/a_smartIcons/si_fullLogo";
    import {gv_zIndex} from "@/scripts/S_GlobalVar";
    import {date_setTimeout} from "@/scripts/S_Date";
    import {enum_moveToOptions} from "../../../functions/src/shareCode/Share_S_Enum";
    import { FB_WhiteLabel } from '../../../functions/src/shareCode/Share_S_Classes';

    export default {
        name: "C_App_SplashScreen",
        components: {FullLogo},
        props:{
            p_whiteLabel_c:{
                type: FB_WhiteLabel
            },
        },
        data(){
            return {
                showSplashScreen_b  : true,
                gv_zIndex           : gv_zIndex,
            }
        },
        computed:{
            co_ongoing_b(){
                const path_s = window.location.href.toLowerCase()
                return path_s.includes(enum_moveToOptions.ongoing)
            },
            co_playerEntryTicket_b(){
                const path_s = window.location.href.toLowerCase()
                return path_s.includes(enum_moveToOptions.player_play_entry_ticket)
            },
            co_showSplashScreen_b() {
                const path_s = window.location.href.toLowerCase()

                return this.showSplashScreen_b
                    && !path_s.includes(enum_moveToOptions.standAlong_paymentFailed)
                    && !path_s.includes(enum_moveToOptions.standAlong_paymentSuccess)
                    && !path_s.includes(enum_moveToOptions.player_store_whiteLabel)
            }
        },
        created(){
            date_setTimeout(() => {
                this.showSplashScreen_b = false
            },3500, this.$options.name)
        }
    }
</script>

<style scoped lang="scss">

    /* splash screen*/
    .lc_splashContainer {
        position: fixed;
        top: 0;
        height: 100vh;
        width: 100vw;

        .lc_logo{
            border-radius: 20px;
        }

        .lc_url {
            letter-spacing: 2px;
            font-size: 20px;
        }


    }


</style>